import { render, staticRenderFns } from "./ConfirmContact.vue?vue&type=template&id=0642aa26&scoped=true"
import script from "./ConfirmContact.vue?vue&type=script&lang=js"
export * from "./ConfirmContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0642aa26",
  null
  
)

export default component.exports